import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const location = useLocation();

  // Check if we're on a minimal navigation page (like /get-started or /start-your-business-today)
  const isMinimalNav = location.pathname === '/get-started' || location.pathname === '/start-your-business-today';
  const isStartBusinessPage = location.pathname === '/start-your-business-today' || location.pathname === '/start-your-business-today/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      // Update active section based on scroll position
      const sections = ['hero', 'projects', 'services', 'process', 'testimonials', 'contact'];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { id: 'hero', label: 'Home' },
    { id: 'projects', label: 'Work' },
    { id: 'services', label: 'Services' },
    { id: 'process', label: 'Process' },
    { id: 'testimonials', label: 'Testimonials' },
    { id: 'contact', label: 'Contact' }
  ];

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''} ${isMinimalNav ? 'minimal' : ''} ${isStartBusinessPage ? 'start-business' : ''}`}>
      <div className="container">
        <div className="nav-content">
          {isStartBusinessPage ? (
            <>
              <Link to="/" className="logo">
                STOREZI
              </Link>
              <Link
                to="/get-started"
                className="btn-primary"
              >
                Get Started
              </Link>
            </>
          ) : isMinimalNav ? (
            <Link to="/" className="logo">
              STOREZI
            </Link>
          ) : (
            <>
              <button
                className="logo"
                onClick={() => scrollToSection('hero')}
              >
                STOREZI
              </button>

              <button
                className={`mobile-toggle ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                aria-label="Toggle menu"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>

              <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
                {navLinks.map(link => (
                  <li key={link.id}>
                    <button
                      className={`nav-link ${activeSection === link.id ? 'active' : ''}`}
                      onClick={() => scrollToSection(link.id)}
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
                <li className="nav-cta">
                  <Link
                    to="/get-started"
                    className="btn-primary"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Get Started
                  </Link>
                </li>
              </ul>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
